import { useAuth } from "../../../features/auth/hooks";
import { userRoles } from "../../../features/user/types/user.types";
import SidebarView, { NavButtonProps } from "./SideBarView/SidebarView";

/**
 * Side Navigation bar
 * @returns
 */
export default function SideBar() {
  const { userLogged, userRole, organizationIdUser } = useAuth();
  let navButtonList: NavButtonProps[] = [];

  if (!userLogged) {
    return <></>;
  }

  if (
    userRole === userRoles.ADMIN ||
    userRole === userRoles.USER
  ) {
    const base = "admin";
    navButtonList = [
      {
        label: "Home",
        iconName: "home",
        to: `/${base}`,
      },

      {
        label: "Stations",
        iconName: "electricStation",
        to: `/${base}/stations`,
        regexEqualURL: new RegExp(`^/${base}/stations(/.*)?$`),
      },

      {
        label: "PayGo",
        iconName: "coin",
        to: `/${base}/paygos`,
        regexEqualURL: new RegExp(`^/${base}/paygos(/.*)?$`),
      },
      
      
      {
        label: "Organisations",
        iconName: "building",
        to: `/${base}/organizations/${organizationIdUser}`,
        regexEqualURL: new RegExp(`^/${base}/organizations(/.*)?$`),
      },
      {
        label: "Rechargements",
        iconName: "plug-icon",
        to: `/${base}/charging-sessions`,
        regexEqualURL: new RegExp(`^/${base}/charging-sessions(/.*)?$`),
      },
      {
        label: "Utilisateurs",
        iconName: "peoples",
        //to: `/${base}/users`,
        regexEqualURL: new RegExp(`^/${base}/users(/.*)?$`),
        childrensBtn:[
          {
            label: "Utilisateurs",
            to: `/${base}/users`,
            regexEqualURL: new RegExp(`^/${base}/users?$`),
          },
          {
            label: "Invitations",
            to: `/${base}/users/invitations`,
            regexEqualURL: new RegExp(`^/${base}/users/invitations(/.*)?$`),
          }
        ]
      },
    ];
  }

  if (userRole === userRoles.SUPER_ADMIN) {
    const base = "sup-admin";
    navButtonList = [
      {
        label: "Home",
        iconName: "home",
        to: `/${base}`,
      },

      {
        label: "Stations",
        iconName: "electricStation",
        to: `/${base}/stations`,
        regexEqualURL: new RegExp(`^/${base}/stations(/.*)?$`),
      },

      {
        label: "PayGo",
        iconName: "coin",
        to: `/${base}/paygos`,
        regexEqualURL: new RegExp(`^/${base}/paygos(/.*)?$`),
      },
      
      {
        label: "Clients",
        iconName: "people-star",
        to: `/${base}/client-extends`,
        regexEqualURL: new RegExp(`^/${base}/client-extends(/.*)?$`),
      },
      {
        label: "Rechargements",
        iconName: "plug-icon",
        to: `/${base}/charging-sessions`,
        regexEqualURL: new RegExp(`^/${base}/charging-sessions(/.*)?$`),
      },

      {
        label: "Hardwares",
        iconName: "ship",
        to: `/${base}/hardwares`,
        regexEqualURL: new RegExp(`^/${base}/hardwares(/.*)?$`),
      },
      {
        label: "Utilisateurs",
        iconName: "peoples",
        //to: `/${base}/users`,
        regexEqualURL: new RegExp(`^/${base}/users(/.*)?$`),
        childrensBtn:[
          {
            label: "Utilisateurs",
            to: `/${base}/users`,
            regexEqualURL: new RegExp(`^/${base}/users?$`),
          },
          {
            label: "Invitations",
            to: `/${base}/users/invitations`,
            regexEqualURL: new RegExp(`^/${base}/users/invitations(/.*)?$`),
          }
        ]
      },
      {
        label: "Organisations",
        iconName: "building",
        onClick: () => {},
        to: `/${base}/organizations`,
        regexEqualURL: new RegExp(`^/${base}/organizations(/.*)?$`),
        
      },
    ];
  }

  return (
    <div>
      <SidebarView buttonList={navButtonList} />
    </div>
  );
}
